// dependencies
import {
    canShowFeedbackScreen,
    navigateToDeeplink,
    updateFeedbackFlag,
    getNativeChannelDeepLink,
} from "@swiggy-private/checkout-core";

// constants
import { AUTOPAY } from "@payment-client/constants/Autopay";

// helpers
import { getAutopayFeedbackUrl } from "@payment-client/helpers/Feedback";
import { format } from "@swiggy-private/js-utils";

// create the autopay feedback link for current order
export const createAutopayFeedbackLink = (orderId?: string) => {
    const feedbackURL = getAutopayFeedbackUrl();
    const autopayFeedbackLink = format(
        getNativeChannelDeepLink(AUTOPAY.FEEDBACK_DEEPLINK),
        encodeURIComponent(format(feedbackURL, encodeURIComponent(orderId ?? ""))),
    );

    return autopayFeedbackLink;
};

// show feedback screen if conditions are fulfilled
export const handleAutopayFeedback = async (orderId?: string) => {
    // create feedback link and read flag
    const autopayFeedbackLink = createAutopayFeedbackLink(orderId);
    const canShowFeedback = await canShowFeedbackScreen(AUTOPAY.FEEDBACK_SHOWN);

    if (!canShowFeedback) {
        return;
    }
    navigateToDeeplink(autopayFeedbackLink);

    // updating autopay feedback storage key
    updateFeedbackFlag(AUTOPAY.FEEDBACK_SHOWN);
};
